export default __webpack_public_path__ + "static/media/1056.80eab9ea.png";